import { PayloadAction } from '@reduxjs/toolkit';
import { call, put, takeLatest } from 'redux-saga/effects';

import api from 'src/services/graphicsApi';

import {
  RECEIVE_MOS_STATUS,
  REQUEST_GET_MOS_STATUS,
  REQUEST_MOS_RESYNC_PLAYLIST,
  REQUEST_TOGGLE_MOS_AUTO_FETCH,
} from '../reducers/mos';
import { NOTIFY } from '../reducers/notification';

function* mosResyncPlaylist(action: PayloadAction<{ mosId: string; roId: string }>) {
  try {
    const { mosId, roId } = action.payload;
    yield call(api.post, `/mos/rundown/sync`, { mosId, roId });
  } catch (error) {
    yield put({
      type: NOTIFY,
      payload: {
        variant: 'error',
        title: 'Error',
        description: 'Could not resync MOS playlists',
      },
    });
  }
}

function* getMosStatus(action: PayloadAction<{ mosId: string }>) {
  try {
    const { mosId } = action.payload;
    const { data } = yield call(api.get, `/mos/status`, { mosId });

    yield put({ type: RECEIVE_MOS_STATUS, payload: data });
  } catch (error) {
    yield put({
      type: NOTIFY,
      payload: {
        variant: 'error',
        title: 'Error',
        description: 'Could not get MOS status',
      },
    });
  }
}

function* toggleMosAutoFetch(action: PayloadAction<{ mosId: string; enabled: boolean }>) {
  try {
    const { mosId, enabled } = action.payload;
    const { data } = yield call(api.patch, `/mos/auto-fetch`, { mosId, enabled });

    yield put({ type: RECEIVE_MOS_STATUS, payload: data });
  } catch (error) {
    yield put({
      type: NOTIFY,
      payload: {
        variant: 'error',
        title: 'Error',
        description: 'Could not toggle MOS auto fetch',
      },
    });
  }
}

export default function* root() {
  yield takeLatest(REQUEST_MOS_RESYNC_PLAYLIST, mosResyncPlaylist);
  yield takeLatest(REQUEST_GET_MOS_STATUS, getMosStatus);
  yield takeLatest(REQUEST_TOGGLE_MOS_AUTO_FETCH, toggleMosAutoFetch);
}
